import React from 'react';
import classNames from 'classnames/bind';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { ListStore } from '../../store';
import { changeEventList, changeEventListType } from '../../utils';
import styles from './index.css';
import LiveNotice from './LiveNotice';

const cx = classNames.bind(styles);

const Filter = () => {
    const listStore = ListStore.useContainer();
    const { listStates, changeListStates } = listStore;
    const { id, size, party, highlights, order, parties, allFold, navHeight } = listStates;

    const handleTabClick = async newParty => {
        if (window && window.timelineReset) {
            window.timelineReset();
        }

        if (newParty !== party) {
            changeListStates({ party: newParty });

            try {
                await changeEventList({
                    query: {
                        id,
                        page: 1,
                        size,
                        party: newParty,
                        highlights,
                        order,
                    },
                    type: changeEventListType.refresh,
                    changeData: changeListStates,
                });
            } catch (e) {
                console.error(e);
            }
        }
    };

    const handleHighlightsClick = async () => {
        if (window && window.timelineReset) {
            window.timelineReset();
        }

        const newHighlights = highlights === 1 ? 0 : 1;

        changeListStates({ highlights: newHighlights });

        try {
            await changeEventList({
                query: {
                    id,
                    page: 1,
                    size,
                    party,
                    highlights: newHighlights,
                    order,
                },
                type: changeEventListType.refresh,
                changeData: changeListStates,
            });
        } catch (e) {
            console.error(e);
        }
    };

    const handleSortClick = async () => {
        if (order === '') {
            return;
        }
        if (window && window.timelineReset) {
            window.timelineReset();
        }
        const newOrder = order === 'asc' ? 'desc' : 'asc';

        changeListStates({ order: newOrder });

        try {
            await changeEventList({
                query: {
                    id,
                    page: 1,
                    size,
                    party,
                    highlights,
                    order: newOrder,
                },
                type: changeEventListType.refresh,
                changeData: changeListStates,
            });
        } catch (e) {
            console.error(e);
        }
    };

    const handleFoldClick = () => {
        changeListStates({ allFold: !allFold });
    };

    return (
        <>
            <div className={styles.tagWrap} style={{ top: navHeight }}>
                <div className={styles.tagScroll}>
                    <div className={styles.tagList}>
                        {parties.map(item => {
                            const { id, name, color } = item;
                            const current = id === party;

                            return (
                                <div
                                    className={styles.tag}
                                    key={id}
                                    style={
                                        current
                                            ? {
                                                  borderColor: color,
                                                  backgroundColor: color,
                                                  color: '#fff',
                                              }
                                            : {
                                                  borderColor: color,
                                                  backgroundColor: '#fff',
                                                  color,
                                              }
                                    }
                                    onClick={() => {
                                        handleTabClick(id);
                                    }}>
                                    <div>{name}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <LiveNotice />
            <div className={styles.actionWrap}>
                <div className={styles.actionLeft}>
                    <div
                        className={cx('highlights', { highlightsOnly: highlights === 1 })}
                        onClick={handleHighlightsClick}>
                        <div className={styles.iconPoint} />
                        <div>看重点</div>
                    </div>
                    <div className={styles.foldWrap} onClick={handleFoldClick}>
                        <div className={cx('foldIcon', { allFoldIcon: allFold })} />
                        {allFold ? '全部展开' : '全部收起'}
                    </div>
                </div>
                <div className={styles.actionRight}>
                    <div className={styles.sortWrap} onClick={handleSortClick}>
                        <div className={`${styles.sortBtn} ${order === 'asc' ? styles.sortBtnCurrent : ''}`}>正序</div>
                        <div className={`${styles.sortBtn} ${order === 'desc' ? styles.sortBtnCurrent : ''}`}>倒序</div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default errorBoundary(Filter);
